import { SampleCartPayload } from 'api/services/RequestContacts';
import { Countries } from 'api/types/countries';
import { translateReverse } from 'api/types/ReferenceData';
import { QuantityUnitType } from 'api/types/ReferenceDataTS';
import dayjs from 'dayjs';
import { RequestTypes } from 'types/ContactRequests';
import { CartState } from '../../contexts/cart/types';
import {
  ShippingDetailsSectionState,
  ShippingDetailsSectionStateType
} from './shippingDetailsSection/ShippingDetailsSection';

export const createSampleCartPayload = (
  data: CartState,
  shippingAddressSectionState: ShippingDetailsSectionState
): SampleCartPayload => {
  const requestBody: SampleCartPayload = {
    type: RequestTypes.SAMPLE,
    message: data.message,
    shipping_address:
      shippingAddressSectionState.type ===
      ShippingDetailsSectionStateType.FROM_PROFILE
        ? {
            ...shippingAddressSectionState.userProfile.shipping_address,
            phone_number: shippingAddressSectionState.userProfile.phone_number
          }
        : {
            company: data.shippingDetails.company,
            person_of_contact: data.shippingDetails.name,
            city: data.shippingDetails.city,
            country: data.shippingDetails.country,
            postal_code: data.shippingDetails.postCode,
            street: data.shippingDetails.street,
            street_additional: data.shippingDetails.street2,
            country_code: translateReverse(
              data.shippingDetails.country,
              Countries
            ),
            phone_number: data.shippingDetails.phoneNumber
          },
    requests: data.items.map(item => ({
      product_id: {
        product: item.product_id.product,
        company: item.product_id.company,
        segment: item.product_id.segment
      },
      quantity_required: item.quantity,
      estimate_usage: item.estimatedYearlyUsage,
      needed_by: dayjs(item.neededBy).startOf('day').toISOString(),
      quantity_required_units: QuantityUnitType.UNIT,
      estimated_usage_units: QuantityUnitType.KILOGRAM
    }))
  };

  return requestBody;
};
